import { deleteGroup } from 'common/constants/permissions';

const canDeleteGroup = permissions => permissions[deleteGroup] || [];

export default {
    canDeleteGroup
};
